import {callApi} from '../common/services/baseServices';
import {host} from '../environment';
import {getCookie} from '../common/enum';
import moment from 'moment';
import axios from '../axios';


const ACTIONS = {
    GET_DATA_ADMIN_NEWS_SUCCESS: 'GET_DATA_ADMIN_NEWS_SUCCESS',
    GET_DATA_ERROR: 'GET_DATA_ERROR',
    ADD_NEWS_SUCCESS: 'ADD_NEWS_SUCCESS',
    ADD_NEWS_ERROR: 'ADD_NEWS_ERROR',
    DELETE_NEWS_SUCCESS: 'DELETE_NEWS_SUCCESS',
    DELETE_NEWS_ERROR: 'DELETE_NEWS_ERROR',
    GET_COMPANY_SUCCESS: 'GET_COMPANY_SUCCESS',
    GET_COMPANY_ERROR: 'GET_COMPANY_ERROR',
    GET_DETAIL_NEWS_SUCCESS: 'GET_DETAIL_NEWS_SUCCESS',
    GET_DETAIL_NEWS_ERROR: 'GET_DETAIL_NEWS_ERROR',
    UPDATE_NEWS_SUCCESS: 'UPDATE_NEWS_SUCCESS',
    UPDATE_NEWS_ERROR: 'UPDATE_NEWS_ERROR'
};


const updateStatus = (type, data) => ({
    type,
    data,
});


const getNotices = (page, keyword) => {
    return async (dispatch) => {
        try {
            const response = await axios.get(`api/admin/notices?sort=id&order=desc&keyword=${keyword}&page=${page}`, {});
            dispatch(updateStatus(ACTIONS.GET_DATA_ADMIN_NEWS_SUCCESS, response.data));
        }catch (error) {
            dispatch(updateStatus(ACTIONS.GET_DATA_ERROR, error));
        }
    };
}

const getDetailNew = (id) => {
    return async (dispatch) => {
        try {
            const response = await axios.get(`api/admin/notices/${id}`, {});
            dispatch(updateStatus(ACTIONS.GET_DETAIL_NEWS_SUCCESS, response.data));
        }catch (error) {
            dispatch(updateStatus(ACTIONS.GET_DETAIL_NEWS_SUCCESS, error));
        }
    };
}

const addNewsAdmin = (data) => {
    return async (dispatch) => {
        try {
            await axios.post(`api/admin/notices`, {
                content: data.content,
                opened_at: data.time,
                companies: data.companies
            });
            dispatch(updateStatus(ACTIONS.ADD_NEWS_SUCCESS, data));
        }catch (error) {
            dispatch(updateStatus(ACTIONS.ADD_NEWS_ERROR, error.response.data));
        }
    };
}

const updateNews = (data, id) => {
    return async (dispatch) => {
        try {
            await axios.put(`api/admin/notices/${id}`, {
                content: data.content,
                opened_at: data.time,
                companies: data.companies
            });
            dispatch(updateStatus(ACTIONS.UPDATE_NEWS_SUCCESS, data));
        }catch (error) {
            dispatch(updateStatus(ACTIONS.UPDATE_NEWS_ERROR, error.response.data));
        }
    };
}

const deleteNewsAdmin = (id) => {
    return async (dispatch) => {
        try {
            const response = await axios.delete(`api/admin/notices/${id}`, {});
            dispatch(updateStatus(ACTIONS.DELETE_NEWS_SUCCESS, response.data));
        }catch (error) {
            dispatch(updateStatus(ACTIONS.DELETE_NEWS_ERROR, error.response.data));
        }
    };
}
// convert
const convertAdminNews = (data) => {
    let now = moment();
    return data.map(items => {
        let allCompany = ``;

        items.companies.map(v => {
            allCompany += `${v.name}, `;
            return true;
        })
        allCompany = allCompany.substring(0, allCompany.length - 2);
        return {
            item: [
                {text: items.content, id: items.id},
                {text: allCompany},
                {text: moment(items.opened_at, 'YYYY-MM-DD HH:mm:ss').format('YYYY/MM/DD HH:mm')},
                now < moment(items.opened_at, 'YYYY-MM-DD HH:mm:ss') ? {
                    action: [
                        '編集', '削除'
                    ]
                } : {
                    action: [
                        '編集'
                    ]
                }
            ]
        }
    });
};

// get list company
const listCompany = () => {
    return async (dispatch) => {
        try {
            const response = await axios.get(`api/admin/customers/companies`, {});
            dispatch(updateStatus(ACTIONS.GET_COMPANY_SUCCESS, response.data));
        }catch (error) {
            dispatch(updateStatus(ACTIONS.GET_COMPANY_ERROR, error));
        }
    };
}

export {ACTIONS, getNotices, convertAdminNews, addNewsAdmin, deleteNewsAdmin, listCompany, getDetailNew, updateNews};
